import { Button } from "@omni/ui/components/Button/button.component";
import { cn } from "@omni/utils/styles";
import React from "react";

import { useGranite } from "@/redux/modules/value/translations/translations.provider";

type ShowMoreProps = {
    showMore: () => void;
    isShowingMore: boolean;
    className?: string;
};

const ShowMoreComponent = ({
    showMore,
    isShowingMore,
    className
}: ShowMoreProps) => {
    const { t } = useGranite();

    const handleOnShowMoreClick = (
        event: React.SyntheticEvent<HTMLButtonElement, Event>
    ) => {
        event.stopPropagation();
        event.target instanceof HTMLElement && event.target.blur();
        showMore();
    };

    return (
        <Button
            className={cn("tw:px-0 tw:text-left", className)}
            color={"link"}
            onClick={handleOnShowMoreClick}
        >
            {isShowingMore ? (
                <>
                    <i className={cn("las la-angle-up", "tw:mr-2")} />
                    {t("search.refinements.showLess")}
                </>
            ) : (
                <>
                    <i className={cn("las la-angle-down", "tw:mr-2")} />
                    {t("search.refinements.showMore")}
                </>
            )}
        </Button>
    );
};

export { ShowMoreComponent };
